import React from 'react';
import { ReactComponent as LogoutIcon } from 'assets/icons/logout-icon.svg';
import LocalModal from 'components/base/local-modal';
import { Button } from '@cokitchen/cokitchen-components';
import useOrdersContext from 'contexts/orders.context';
import { useNavigate } from 'react-router-dom';
type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const CancelCalculatedOrderModal = ({ isOpen, onClose }: Props) => {
  const { handleReset } = useOrdersContext();

  const navigate = useNavigate();
  const handleClearOrder = () => {
    handleReset();
    navigate('/orders');
  };
  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose} title=''>
      <div className='w-[80%] mx-auto flex flex-col justify-center items-center'>
        <LogoutIcon />
        <p className='text-gray-10'> Are you sure you want to cancel Order?</p>
        <p className='text-center text-gray-9 text-sm'>Your basket will be cleared if you do</p>
        <div className='w-full flex gap-4 justify-center'>
          <Button
            variant='block'
            color='gray'
            className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
            onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            className='mt-8 h-[41px] w-[139px]'
            onClick={handleClearOrder}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default CancelCalculatedOrderModal;
